import CuentaDelete from './CuentaDelete'
export {CuentaDelete}
export default CuentaDelete
